import reducer from "./reducer";
export { default as AssetsDiscountsEntryByImport } from "./components/index";
export { default as assetsDiscountsEntryByImportReducerName } from "./constants";
export default reducer;
